// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__V31uL","containerItemsCenter":"Skeleton_containerItemsCenter__2zsmb"};